import React, { useContext, useEffect, useState } from "react";

import { Spin } from "antd";
import { courseName } from "../../utils";
import { _ListCourseSubjects } from "../../models/subjectModel";
import LoadCourseWiseSubjectList from "./loadCourseWiseSubjectList";
import PsContext from "../../context";

const LoadCourseList = ({ item }) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [selectedType, setSelectedType] = useState([]);
  const [selectedTypeKey, setSelectedTypeKey] = useState(null);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    _ListCourseSubjects({
      course_level_id: item.course_level_id,
      college_uuid: item.college_uuid,
      //dept_type: item.dept_type,
      coursetype: item.coursetype,
    }).then((res) => {
      if (res.status == "1") setDataList(res.data);
      setLoader(false);
    });
  };

  const handleRowClick = (data, key) => {
    if (selectedTypeKey == key) {
      setSelectedType([]);
      setSelectedTypeKey(null);
    } else {
      setSelectedType(data);
      setSelectedTypeKey(key);
    }
  };

  return (
    <div style={{ minHeight: "40px" }} className="mt-2">
      <Spin spinning={loader}>
        {dataList && dataList.length > 0 && (
          <table width="97%" align="center">
            <tbody className="bg-light">
              {dataList.map((item, i) => {
                return (
                  <tr key={i}>
                    <td className="p-3 border-bottom fw-bold cursor-pointer">
                      <div onClick={(e) => handleRowClick(item, i)}>
                        {courseName(item, true)}
                        <span
                          className="float-end"
                          style={{
                            color: `${context.settingValue(
                              "web_site_header_textcolor"
                            )}`,
                          }}
                        >
                          {selectedTypeKey == i ? (
                            <i className="fa-solid fa-chevron-up"></i>
                          ) : (
                            <i className="fa-solid fa-chevron-down"></i>
                          )}
                        </span>
                      </div>
                      {selectedTypeKey == i && (
                        <LoadCourseWiseSubjectList item={item} />
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </Spin>
    </div>
  );
};
export default LoadCourseList;
